/**
 * Created by alvinoktavianus on 6/21/17.
 */

import { isFSA } from 'flux-standard-action'
import invariant from 'invariant'
import {
  BILLING_REDIRECT_SET_NOTIFICATION_MESSAGE,
  BILLING_REDIRECT_SET_NOTIFICATION_TYPE
} from 'actions/billingRedirect/constant'

let initialState = {
  notificationMessage: null,
  notificationType: null
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  const {payload = {}} = action

  switch (action.type) {
    case BILLING_REDIRECT_SET_NOTIFICATION_TYPE:
      return {...state, notificationType: payload.notifType}
    case BILLING_REDIRECT_SET_NOTIFICATION_MESSAGE:
      return {...state, notificationMessage: payload.notifMessage}
    default:
      return {...state}
  }
}

export { reducer }



// WEBPACK FOOTER //
// ./app/reducers/billingRedirect/billingRedirect.js